<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :key="pageKey"
    :formsConfig="formsConfig"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :hot-key-grid-tab-index="-1"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Product"
        :baseView="baseView"
        :primaryLabel="model.Code"
        :secondaryLabel="model.Description1"
        recordType="Product"
      />
    </template>

    <div class="css-v2 gc-master-screen">
      <DxToolbar class="view-toolbar">
        <DxItem
          widget="dxForm"
          location="before"
          :options="{
            formData: model,
            items: toolbarFormItems,
            validationGroup: 'toolbarForm',
            labelLocation: 'left',
            disabled: baseView.mode == 'review' ? true : false,
          }"
          locate-in-menu="auto"
          :disabled="baseView.mode == 'review' ? true : false"
        ></DxItem>

        <DxItem
          widget="dxForm"
          location="after"
          :options="{
            formData: model,
            items: toolbarActiveItems,
            validationGroup: 'toolbarActive',
            labelLocation: 'left',
            disabled: baseView.mode == 'review' ? true : false,
          }"
          locate-in-menu="after"
          :disabled="baseView.mode == 'review' ? true : false"
          v-if="dataLoaded"
        ></DxItem>
        <DxItem
          :options="toolbar.audit"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode == 'review'"
        />
        <DxItem
          :options="toolbar.edit"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode == 'review'"
        />

        <DxItem
          :options="toolbar.save"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode != 'review'"
        />

        <DxItem
          :options="toolbar.copy"
          location="after"
          locate-in-menu="auto"
          widget="dxDropDownButton"
          v-if="baseView.mode === 'review'"
        />
      </DxToolbar>

      <div class="view-card responsive-paddings product-detail-form">
        <form v-if="dataLoaded">
          <DxForm
            :form-data.sync="model"
            :read-only="false"
            :show-colon-after-label="false"
            :show-required-mark="false"
            :show-validation-summary="false"
            :validation-group="formsConfig.validationGroup"
            label-location="left"
            :customizeItem="customizeItem"
            :items="items.items"
            :ref="'product-details'"
          >
            <!-- <template #PrimeCostItemTemplate>
            <div id="PrimeCostItemToolTip" class="dxTooltip">Some Text</div>
          </template>-->
            <template #ProductTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description1
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #ProductCategory1Template="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #PreferredSupplierTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{ data.Name }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #ProductCategory2Template="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #ProductCategory3Template="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #ProductCategory4Template="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #ProductTypeTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #ProductSizeTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #TaxCategoryTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #UnitOfMeasureTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>

            <template #kitItemTemplate="{ data }">
              <div
                class="kitItem-Template"
                v-if="model.KitItem && baseView.mode != 'review'"
              >
                <span class="label-content" @click="showProductKits">
                  Edit
                </span>
              </div>
            </template>
            <template #BOMTemplate="{ data }">
              <div class="custom-auto-complete" id="{ data.code }">
                <span class="auto-complete-primary">{{
                  data.Description1
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
          </DxForm>
        </form>
      </div>

      <div class="attribute-content" v-if="dataLoaded">
        <gc-form
          :formOptions="{
            gcLabelLocation: 'left',
          }"
          :formItems="getAttributeFormItems"
          :formHeight="200"
          :isNormal="true"
          :data-model="model"
          :formMode="'create'"
          :validationGroup="'gc-popup-call-scheduler-call-log'"
          :formTitle="'gc-popup'"
          :ref="'bank-fee'"
          :setCustomizeItem="customizeItem"
        ></gc-form>
      </div>

      <GcPopupProductKits
        v-if="visibleProductKits"
        :setVisible="visibleProductKits"
        :callBack="hideProductKits"
        :model="model"
        :productKitDetails="productKitDetails"
      />

      <gcPopupCopyProduct
        :visible="getCopyProductVisible"
        @setCopyProductVisible="setCopyProductVisible"
        :popUpConfig="popUpConfig"
        v-if="getCopyProductVisible"
        @reloadProductDetailData="loadProductDetailData"
        :displayServerError="displayServerError"
      />
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";

import { TaxCategoryService } from "../../_services/api/settings/accounting/tax-category.service";
import validationEngine from "devextreme/ui/validation_engine";
import { ProductService } from "../../_services/api/products/product.service";
import { SupplierService } from "../../_services/api/suppliers/supplier.service";
import { ProductCategory1Service } from "../../_services/api/settings/products/product-category-1.service";
import { ProductCategory2Service } from "../../_services/api/settings/products/product-category-2.service";
import { ProductCategory3Service } from "../../_services/api/settings/products/product-category-3.service";
import { ProductCategory4Service } from "../../_services/api/settings/products/product-category-4.service";
import { ProductSizeService } from "../../_services/api/settings/products/product-size.service";
import { ProductTypeService } from "../../_services/api/settings/products/product-type.service";
import { UnitOfMeasureService } from "../../_services/api/settings/products/unit-of-measure.service";
import {
  ProductTabs,
  ProductTabsVisibility,
} from "../../_models/tabdata/products/products-tabs";
import { getFactorByCode } from "../../_store/helpers";

import gcPopupCopyProduct from "../../popups/products/gc-popup-copy-product.vue";
import { FeatureStorage } from "../../_services/storage";

export default {
  props: {},
  components: {
    gcPopupCopyProduct,
  },
  mixins: [BaseViewMixin],
  mounted() {
    if (this.dataLoaded) {
      validationEngine.validateGroup(this.formsConfig.validationGroup);
      validationEngine.validateGroup("toolbarForm");
      validationEngine.validateGroup("toolbarActive");
    }
  },
  async created() {
    let that = this;
    if (this.baseView.mode != "review") {
      await this.$store.dispatch("screenFactors/getFactors", [73]);
    }
    if (
      this.baseView.mode === "review" ||
      this.baseView.mode === "edit"
      // && this.baseView.id.length == 36
    ) {
      this.model.Code = this.baseView.id;

      await this.loadProductDetailData(this.baseView.id);
    } else {
      let { data } = await SupplierService.getAllSupplier();
      this.supplierList = data.value;
      this.dataLoaded = true;
      ProductService.getDefaultCategories().then(({ data }) => {
        if (data.value[0].ProductCategory1IsDefault == "Y")
          that.model.ProductCategory1Code = data.value[0].ProductCategory1Code;
        if (data.value[0].ProductCategory2IsDefault == "Y")
          that.model.ProductCategory2Code = data.value[0].ProductCategory2Code;
        if (data.value[0].ProductCategory3IsDefault == "Y")
          that.model.ProductCategory3Code = data.value[0].ProductCategory3Code;
        if (data.value[0].ProductCategory4IsDefault == "Y")
          that.model.ProductCategory4Code = data.value[0].ProductCategory4Code;
      });
      TaxCategoryService.getDefault().then(({ data }) => {
        if (data.value.length > 0) that.model.TaxCode = data.value[0].Code;
      });
    }
  },
  watch: {
    $route(to) {
      if (to.path == "/product/create") {
        location.reload();
      }
    },
  },
  updated() {
    if (this.dataLoaded) {
      validationEngine.validateGroup(this.formsConfig.validationGroup);
      validationEngine.validateGroup("toolbarForm");
      validationEngine.validateGroup("toolbarActive");
    }
    // this.validateFormConfig();
    // let isInReview = false;
    // if (this.baseView.mode == "review") {
    //   this.baseView.mode = "edit";
    //   isInReview = true;
    // }
    //  that.validateFormConfig();
    // if (isInReview) {
    //   this.baseView.mode = "review";
    // }
    // this.$logger.debug('updated', this.dataLoaded);
  },
  data() {
    return {
      supplierList: [],
      model: {
        PreferredSupplier: "",
        Currency: undefined,
        SellPrice: 0.0,
        SupplierConversion: 1.0,
        SupplierUM: "EA",
        SupplierPrice: 0.0,
        Code: "",
        AlternateProductCode: "",
        APN: "",
        Active: true,
        Description1: "",
        Description2: "",
        Description3: "",
        FullDescription: "",
        ProductCategory1Code: "",
        ProductCategory2Code: "",
        ProductCategory3Code: "",
        ProductCategory4Code: "",
        ProductTypeCode: "",
        ProductSizeCode: "",
        TaxCode: "",
        IsPrimeCostItem: false,
        StockItem: true,
        AvailableForSale: true,
        UnitOfMeasureCode: "EA", //* *Default from table/factors? */
        // CartonTun: "",
        CartonPerLayer: null,
        CartonPerPallet: null,
        IsBatchProduct: "No",
        Source: undefined,
        ReleaseMode: "",
        Manufacturer: "",
        PurchaseDescription1: "",
        PurchaseDescription2: "",
        DateChanged: "",
        ChangedBy: "",
        DateCreated: "",
        CreatedBy: "",
        stockItemReadOnly: false,
        stockUMReadOnly: false,
        isBatchProductReadOnly: false,
        activeReadOnly: false,
        MLORDays: -1,
        KitItem: false,

        PackSize: 0,
        PrimaryBomCode: undefined,
        PlanningBomCode: undefined,
        PrimaryBomDescription: undefined,
        PlanningBomDescription: undefined,
        ReleaseBatchMethod: "Work Order",
        ShelfLifeMethod: undefined,
        ShelfLifeDays: null,

        BestBeforeShelfLife: undefined,
        UseByShelfLife: undefined,
        MarkupPercentage: 0,
        StorageTemperatureCode: undefined,
        StockJournal: true,
        CartonTun: undefined,
        WorkOrderMaterialCheck: true,
        StandardReleaseQuantity: 0,
        StandardReleaseTolerance: 0,
      },
      dataLoaded: false,
      visibleProductKits: false,
      productKitDetails: undefined,
      isBatchMethodEditable: true,
      inactivateValidationMessage: "",
      CopyProductVisible: false,
      popUpConfig: {},
      isProductHasMovements: false,
      primaryBomCodeHint: "",
      planningBomCodeHint: "",
    };
  },

  computed: {
    getAttributeFormItems() {
      const createAttributeItem = (index) => ({
        screenField: `ProductAttribute${index.toString().padStart(2, "0")}`,
        valueExpr: "RecordId",
        searchExpr: ["Code", "Description"],
        displayExpr: (item) =>
          item ? `${item.Code} - ${item.Description}` : "",
        editorOptions: {
          showClearButton: true,
        },
      });

      // Create 18 items
      const allAttributes = Array.from({ length: 18 }, (_, i) =>
        createAttributeItem(i + 1)
      );

      // Split into 3 groups of 6 items each
      const groupedAttributes = [];
      for (let i = 0; i < 18; i += 6) {
        groupedAttributes.push({
          itemType: "group",
          caption: "",
          items: allAttributes.slice(i, i + 6),
        });
      }

      // Return final structure
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: groupedAttributes,
        },
      ];
    },
    toolbarFormItems() {
      return [
        {
          dataField: "Code",
          width: 500,
          label: { text: "Code", visible: false },
          validationRules: [
            {
              type: "required",
              message: "Code is required",
            },
          ],
          disabled: this.baseView.mode != "create",
          editorOptions: {
            maxLength: 20,
            placeholder: "Product",
            readOnly: this.baseView.mode != "create",
          },
        },
      ];
    },
    toolbarActiveItems() {
      return this.parseFormColumns([
        {
          dataField: "Active",
          gcType: "Boolean",
          gcLabel: "Active",
          disabled: this.baseView.mode === "review",
          editorOptions: {
            hint: this.model.activeReadOnly
              ? "Transactions must be complete and stock must be adjusted out of inventory before deactivating the product" // need both
              : "",
            onValueChanged: async (e) => {
              if (!e.value) {
                if (this.model.activeReadOnly) {
                  var err = await this.$alert(
                    this.inactivateValidationMessage,
                    "Error"
                  );
                  if (err) this.setActive(true);
                }
              }
            },
          },
        },
      ]);
    },
    items() {
      return {
        items: [
          {
            itemType: "group",
            caption: "",
            colCount: 3,
            items: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    itemType: "group",
                    caption: "",
                    items: this.parseFormColumns([
                      {
                        dataField: "Description1",
                        gcLabel: "Description 1",
                        gcType: "String",
                        editorType: "dxTextBox",
                        editorOptions: {
                          maxLength: 200,
                          onChange: this.onDescription1Changed,
                        },
                        required: true,
                      },
                      {
                        dataField: "Description2",
                        gcLabel: "Description 2",
                        gcType: "String",
                        editorType: "dxTextBox",
                        editorOptions: {
                          maxLength: 200,
                          onChange: this.onDescription2Changed,
                        },
                      },
                      {
                        dataField: "Description3",
                        gcLabel: "Description 3",
                        gcType: "String",
                        editorType: "dxTextBox",
                        editorOptions: {
                          maxLength: 50,
                        },
                      },
                      {
                        dataField: "PurchaseDescription1",
                        gcLabel: "Purchase Description 1",
                        gcType: "String",
                        editorType: "dxTextBox",
                        editorOptions: {
                          maxLength: 200,
                        },
                        required: true,
                      },
                      {
                        dataField: "PurchaseDescription2",
                        gcLabel: "Purchase Description 2",
                        gcType: "String",
                        editorType: "dxTextBox",
                        editorOptions: {
                          maxLength: 200,
                        },
                        // required: true,
                      },
                      // {
                      //   dataField: "AlternateProductCode",
                      //   id: "alternateProductCode-selectBox",
                      //   gcLabel: "Alternate Product",
                      //   gcType: "String",
                      //   editorType: "dxSelectBox",
                      //   editorOptions: {
                      //     dataSource: ProductService.dataSourceConfig(
                      //       "api/Product",
                      //       {
                      //         select: ["Code", "Description1"],
                      //         filter: [
                      //           ["Inactive", "=", "N"],
                      //           ["Code", "<>", this.model.Code],
                      //         ],
                      //       }
                      //     ),
                      //     itemTemplate: "ProductTemplate",
                      //     valueExpr: "Code",
                      //     displayExpr: "Description1",
                      //     searchExpr: ["Code", "Description1"],
                      //     searchMode: "contains",
                      //     showClearButton: true,
                      //     searchEnabled: true,
                      //   },
                      // },
                      {
                        dataField: "APN",
                        gcLabel: "APN",
                        gcType: "String",
                        editorType: "dxTextBox",
                        editorOptions: {
                          maxLength: 100,
                        },
                      },
                    ]),
                  },

                  //* *Sales/Purchasing group */
                  {
                    itemType: "group",
                    caption: "",
                    items: this.parseFormColumns([
                      {
                        dataField: "TaxCode",
                        id: "taxCategory-selectBox",
                        gcLabel: "Tax Category",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        editorOptions: {
                          dataSource: TaxCategoryService.dataSourceConfig(
                            "api/Tax",
                            {
                              select: ["Code", "Description"],
                              filter: [["Inactive", "=", "N"]],
                              sort: [{ selector: "Description", asc: true }],
                            }
                          ),
                          itemTemplate: "TaxCategoryTemplate",
                          valueExpr: "Code",
                          displayExpr: "Description",
                          searchExpr: ["Code", "Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                          maxLength: 10,
                        },
                        validationRules: [
                          {
                            type: "required",
                            message: "Tax Category is required",
                          },
                          {
                            type: "async",
                            validationCallback: this.taxCodeExistsRuleCallback,
                            message: "Tax Category does not exist",
                          },
                        ],
                      },
                      {
                        itemType: "group",
                        caption: "",
                        colCount: 2,
                        gcType: "MultiColumn",
                        items: this.parseFormColumns([
                          {
                            dataField: "StockItem",
                            gcLabel: "Stock Journal", // changed label from 'Stock Item' to 'Stock Journal'
                            gcType: "Boolean",
                            disabled: this.model.stockItemReadOnly,
                            editorType: "dxTextBox",
                            editorOptions: {
                              hint: this.model.stockItemReadOnly
                                ? "Stock Journal flag cannot be changed once the product is transacted upon" // need both
                                : "",
                            },
                          },
                          {
                            dataField: "AvailableForSale",
                            gcLabel: "Available For Sale",
                            gcType: "Boolean",
                          },
                          // {
                          //   dataField: "KitItem",
                          //   gcLabel: "Kit Item",
                          //   gcType: "Boolean",
                          //   editorOptions: {
                          //     template: "kitItemTemplate",
                          //   },
                          //   gcLabelVisible: false,
                          //   template: "kitItemTemplate",
                          // },
                        ]),
                      },
                      {
                        itemType: "group",
                        caption: "",
                        colCount: 2,
                        gcType: "MultiColumn",
                        items: this.parseFormColumns([
                          {
                            dataField: "KitItem",
                            gcLabel: "Kit Item",
                            gcType: "Boolean",
                            editorOptions: {
                              // template: "kitItemTemplate",
                              readOnly: this.baseView.mode != "create",
                              onValueChanged: (e) => {
                                this.onKitItemValueChanged(e);
                              },
                            },
                          },
                          {
                            dataField: "KitItem2",
                            gcLabel: "Kit Item",
                            gcType: "Boolean",
                            editorOptions: {
                              template: "kitItemTemplate",
                            },
                            gcLabelVisible: false,
                            template: "kitItemTemplate",
                            cssClass: "kit-edit",
                            // visible: this.baseView.mode != "review",
                          },
                          {
                            dataField: "IsPrimeCostItem",
                            gcLabel: "Prime Cost",
                            gcType: "Boolean",
                            editorOptions: {
                              readOnly: !this.IsIsPrimeCostItemEditable,
                              tabIndex: !this.IsIsPrimeCostItemEditable
                                ? -1
                                : undefined,
                              onValueChanged: (e) => {
                                this.onIsPrimeCostItemValueChanged(e);
                              },
                            },
                          },
                          {
                            dataField: "MarkupPercentage",
                            gcLabel: "Markup %",
                            gcType: "Number",
                            editorType: "dxNumberBox",
                            editorOptions: {
                              min: 0,
                              max: 100,
                              readOnly: !this.model.IsPrimeCostItem,
                              tabIndex: !this.model.IsPrimeCostItem
                                ? -1
                                : undefined,
                              format: "#0.00",
                            },
                          },
                          {
                            dataField: "StockJournal",
                            gcLabel: "Ex Stock Material", // changed label from 'Stock Journal' to 'Ex Stock Material'
                            gcType: "Boolean",
                            editorOptions: {
                              readOnly: this.isProductHasMovements,
                              tabIndex: this.isProductHasMovements
                                ? -1
                                : undefined,
                            },
                          },
                        ]),
                      },
                    ]),
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    itemType: "group",
                    caption: "",
                    items: this.parseFormColumns([
                      {
                        dataField: "ProductCategory1Code",
                        id: "productCategory1-selectBox",
                        gcLabel: "Category 1",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        editorOptions: {
                          dataSource: ProductCategory1Service.dataSourceConfig(
                            "api/ProductCategory1",
                            {
                              select: ["Code", "Description"],
                              filter: [["Inactive", "=", "N"]],
                              sort: [{ selector: "Description", asc: true }],
                            }
                          ),
                          itemTemplate: "ProductCategory1Template",
                          valueExpr: "Code",
                          displayExpr: (item) => {
                            if (item)
                              return item.Code + " - " + item.Description;
                            else return "";
                          },
                          searchExpr: ["Code", "Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                        },
                        validationRules: [
                          {
                            type: "required",
                            message: "Category 1 is required",
                          },
                          {
                            type: "async",
                            validationCallback:
                              this.category1ExistsRuleCallback,
                            message: "Category 1 does not exist",
                          },
                        ],
                      },
                      {
                        dataField: "ProductCategory2Code",
                        id: "productCategory2-selectBox",
                        gcLabel: "Category 2",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        editorOptions: {
                          dataSource: ProductCategory2Service.dataSourceConfig(
                            "api/ProductCategory2",
                            {
                              select: ["Code", "Description"],
                              filter: [["Inactive", "=", "N"]],
                              sort: [{ selector: "Description", asc: true }],
                            }
                          ),
                          itemTemplate: "ProductCategory2Template",
                          valueExpr: "Code",
                          displayExpr: (item) => {
                            if (item)
                              return item.Code + " - " + item.Description;
                            else return "";
                          },
                          searchExpr: ["Code", "Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                        },
                        validationRules: [
                          {
                            type: "required",
                            message: "Category 2 is required",
                          },
                          {
                            type: "async",
                            validationCallback:
                              this.category2ExistsRuleCallback,
                            message: "Category 2 does not exist",
                          },
                        ],
                      },
                      {
                        dataField: "ProductCategory3Code",
                        id: "productCategory3-selectBox",
                        gcLabel: "Category 3",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        editorOptions: {
                          dataSource: ProductCategory3Service.dataSourceConfig(
                            "api/ProductCategory3",
                            {
                              select: ["Code", "Description"],
                              filter: [["Inactive", "=", "N"]],
                              sort: [{ selector: "Description", asc: true }],
                            }
                          ),
                          itemTemplate: "ProductCategory3Template",
                          valueExpr: "Code",
                          displayExpr: (item) => {
                            if (item)
                              return item.Code + " - " + item.Description;
                            else return "";
                          },
                          searchExpr: ["Code", "Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                        },
                        validationRules: [
                          {
                            type: "required",
                            message: "Category 3 is required",
                          },
                          {
                            type: "async",
                            validationCallback:
                              this.category3ExistsRuleCallback,
                            message: "Category 3 does not exist",
                          },
                        ],
                      },
                      {
                        dataField: "ProductCategory4Code",
                        id: "productCategory4-selectBox",
                        gcLabel: "Category 4",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        editorOptions: {
                          dataSource: ProductCategory4Service.dataSourceConfig(
                            "api/ProductCategory4",
                            {
                              select: ["Code", "Description"],
                              filter: [["Inactive", "=", "N"]],
                              sort: [{ selector: "Description", asc: true }],
                            }
                          ),
                          itemTemplate: "ProductCategory4Template",
                          valueExpr: "Code",
                          displayExpr: (item) => {
                            if (item)
                              return item.Code + " - " + item.Description;
                            else return "";
                          },
                          searchExpr: ["Code", "Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                        },
                        validationRules: [
                          {
                            type: "required",
                            message: "Category 4 is required",
                          },
                          {
                            type: "async",
                            validationCallback:
                              this.category4ExistsRuleCallback,
                            message: "Category 4 does not exist",
                          },
                        ],
                      },
                      {
                        dataField: "ProductTypeCode",
                        id: "productType-selectBox",
                        gcLabel: "Type",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        editorOptions: {
                          dataSource: ProductTypeService.dataSourceConfig(
                            "api/ProductType",
                            {
                              select: ["Code", "Description"],
                              filter: [["Inactive", "=", "N"]],
                              sort: [{ selector: "Description", asc: true }],
                            }
                          ),
                          itemTemplate: "ProductTypeTemplate",
                          valueExpr: "Code",
                          displayExpr: (item) => {
                            if (item)
                              return item.Code + " - " + item.Description;
                            else return "";
                          },
                          searchExpr: ["Code", "Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                        },
                        validationRules: [
                          {
                            type: "required",
                            message: "Type is required",
                          },
                          {
                            type: "async",
                            validationCallback: this.typeExistsRuleCallback,
                            message: "Type does not exist",
                          },
                        ],
                      },
                      {
                        dataField: "StorageTemperatureCode",
                        gcLabel: "Storage Temp",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        editorOptions: {
                          dataSource: ProductTypeService.dataSourceConfig(
                            "api/StorageTemperature",
                            {
                              select: ["Code", "Description"],
                              filter: [["Inactive", "=", "N"]],
                              sort: [{ selector: "Description", asc: true }],
                            }
                          ),
                          itemTemplate: (data) => {
                            return ` <div class="custom-auto-complete" id="${data.Code}" >
                            <span class="auto-complete-primary">
                              ${data.Description}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.Code}
                            </span>
                          </div>`;
                          },
                          valueExpr: "Code",
                          displayExpr: (item) => {
                            if (item)
                              return item.Code + " - " + item.Description;
                            else return "";
                          },
                          searchExpr: ["Code", "Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                        },
                      },
                      {
                        dataField: "ProductSizeCode",
                        id: "productSize-selectBox",
                        gcLabel: "Size",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        editorOptions: {
                          dataSource: ProductSizeService.dataSourceConfig(
                            "api/ProductSize",
                            {
                              select: ["Code", "Description", "Sequence"],
                              filter: [["Inactive", "=", "N"]],
                              sort: [{ selector: "Sequence", asc: true }],
                            }
                          ),
                          itemTemplate: "ProductSizeTemplate",
                          valueExpr: "Code",
                          displayExpr: (item) => {
                            if (item)
                              return item.Code + " - " + item.Description;
                            else return "";
                          },
                          searchExpr: ["Code", "Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                        },
                        validationRules: [
                          // {
                          //   type: "required",
                          //   message: "Size is required",
                          // },
                          {
                            type: "async",
                            validationCallback: this.sizeExistsRuleCallback,
                            message: "Size does not exist",
                          },
                        ],
                      },
                      {
                        dataField: "Source",
                        // id: "productSize-selectBox",
                        gcLabel: "Source",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        required: true,
                        editorOptions: {
                          items: [
                            { Code: "B", Description: "Purchased" },
                            { Code: "M", Description: "Manufactured" },
                          ],
                          // itemTemplate: "ProductSizeTemplate",
                          valueExpr: "Code",
                          displayExpr: "Description",
                          searchExpr: ["Code", "Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                          onValueChanged: (e) => {
                            this.onSourceValueChanged(e);
                          },
                        },
                      },
                      {
                        dataField: "IsBatchProduct",
                        gcLabel: "Batch Method",
                        id: "batch-selectBox",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        required: true,
                        editorOptions: {
                          readOnly:
                            this.model.KitItem || !this.isBatchMethodEditable,
                          tabIndex:
                            this.model.KitItem || !this.isBatchMethodEditable
                              ? -1
                              : undefined,
                          items: [
                            {
                              value: "Manual",
                              text: "Manual",
                            },
                            {
                              value: "Auto",
                              text: "Auto",
                            },
                            {
                              value: "NextNo",
                              text: "Next No",
                            },
                            {
                              value: "No",
                              text: "None",
                              // disabled: this.isProductHasMovements,
                            },
                          ],
                          valueExpr: "value",
                          displayExpr: "text",
                          onValueChanged: this.onBatchMethodChanged,
                          hint: this.model.isBatchProductReadOnly
                            ? "Stock must be adjusted out of inventory before changing the batch method" // need both
                            : "",
                        },
                      },
                      {
                        dataField: "ReleaseBatchMethod",
                        gcLabel: "Release Batch Method",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        editorOptions: {
                          items: [
                            { Description: "Work Order" },
                            { Description: "Scheduled Date Best Before" },
                            { Description: "Scheduled Date Use By" },
                            { Description: "Release Date Work Order" },
                            { Description: "Release Date" },
                            { Description: "Batch Date Work Order" },
                            { Description: "Batch Date" },
                            { Description: "Location + Release Date" },
                            { Description: "Manual Scheduled Date" },
                          ],
                          valueExpr: "Description",
                          displayExpr: "Description",
                          searchExpr: ["Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                          dropDownOptions: {
                            width: 200,
                          },
                        },
                        visible:
                          this.model.Source == "M" &&
                          (this.model.IsBatchProduct == "Auto" ||
                            this.model.IsBatchProduct == "Manual"),
                      },
                    ]),
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                items: [
                  //* *Batching group */
                  {
                    itemType: "group",
                    caption: "",
                    items: this.parseFormColumns([
                      {
                        dataField: "PackSize",
                        gcLabel: "Default Pack Qty",
                        gcType: "Decimal-6-4",
                        cssClass: "dx-numberbox-left",
                        editorOptions: {
                          min: 0,
                          max: 999999999,
                        },
                        // required: true,
                        // visible: this.baseView.mode === "create",
                      },
                      {
                        dataField: "UnitOfMeasureCode",
                        disabled: this.model.stockUMReadOnly,
                        gcLabel: "Stock UM",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        editorOptions: {
                          dataSource: UnitOfMeasureService.dataSourceConfig(
                            "api/UnitOfMeasure",
                            {
                              select: ["Code", "Description"],
                              filter: ["Inactive", "=", false],
                              sort: [{ selector: "Description", asc: true }],
                            }
                          ),
                          itemTemplate: "UnitOfMeasureTemplate",
                          valueExpr: "Code",
                          displayExpr: "Description",
                          searchExpr: ["Code", "Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                          hint: this.model.stockUMReadOnly
                            ? "Stock UM cannot be changed once the product is transacted upon" // need both
                            : "",
                          onValueChanged: (e) => {
                            this.onUnitOfMeasureCodeChanges(e);
                          },
                        },
                        validationRules: [
                          {
                            type: "required",
                            message: "Stock UM is required",
                          },
                          {
                            type: "async",
                            validationCallback: this.stockUMExistsRuleCallback,
                            message: "Stock UM does not exist",
                          },
                        ],
                      },
                      {
                        dataField: "SellPrice",
                        gcType: "Decimal-6-4",
                        cssClass: "dx-numberbox-left",
                        editorOptions: {
                          min: 0,
                          max: 999999999,
                        },
                        required: true,
                        visible: this.baseView.mode === "create",
                      },
                      {
                        dataField: "MLORDays",
                        gcType: "Decimal-9-0",
                        gcLabel: "MLOR Days",
                        visible:
                          this.model.IsBatchProduct == "No" ? false : true,
                        editorOptions: {
                          min: -1,
                          max: 2147483647,
                        },
                      },
                      {
                        dataField: "PreferredSupplier",
                        id: "PreferredSupplier-selectBox",
                        gcLabel: "Preferred Supplier",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        editorOptions: {
                          dataSource: this.supplierList,
                          itemTemplate: "PreferredSupplierTemplate",
                          valueExpr: "Code",
                          displayExpr: "Name",
                          searchExpr: ["Code", "Name"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                          required: false,
                          onValueChanged: ({ value }) => {
                            let supplier = this.supplierList.filter(
                              (supplier) => supplier.Code === value
                            );

                            if (supplier.length > 0) {
                              let currencyCode = supplier[0].CurrencyCode;
                              this.setCurrencyCode(currencyCode);
                            }
                          },
                        },
                        required: true,
                        visible:
                          this.baseView.mode === "create" &&
                          this.model.Source != "M",
                        // validationRules: [
                        //   {
                        //     type: "required",
                        //     message: "Preferred Supplier is required",
                        //   },
                        // ],
                      },
                      {
                        dataField: "Currency",
                        gcLabel: "Currency",
                        gcType: "String",
                        editorType: "dxTextBox",
                        editorOptions: {
                          readOnly: true,
                        },
                        required: true,
                        visible:
                          this.baseView.mode === "create" &&
                          this.model.Source != "M",
                      },
                      {
                        dataField: "SupplierPrice",
                        gcLabel:
                          this.model.Source == "M"
                            ? "Cost Price"
                            : "Supplier Price",
                        gcType: "Decimal-6-4",
                        // format: "Decimal-9-2",
                        cssClass: "dx-numberbox-left",
                        editorType: "dxTextBox",
                        editorOptions: {
                          readOnly: false,
                        },
                        required: true,
                        visible:
                          this.baseView.mode === "create" &&
                          (this.model.StockItem || this.model.AvailableForSale),
                        validationRules: [
                          {
                            type: "required",
                            message: "Supplier Price is required",
                          },
                          {
                            type: "range",
                            message: "Supplier Price must be above $0",
                            min: 0.0,
                          },
                        ],
                      },
                      {
                        dataField: "SupplierPrice",
                        gcLabel:
                          this.model.Source == "M"
                            ? "Cost Price"
                            : "Supplier Price",
                        gcType: "Decimal-6-4",
                        // format: "Decimal-9-2",
                        cssClass: "dx-numberbox-left",
                        editorType: "dxTextBox",
                        editorOptions: {
                          readOnly: false,
                        },
                        required: true,
                        visible:
                          this.baseView.mode === "create" &&
                          !this.model.StockItem &&
                          !this.model.AvailableForSale,
                        validationRules: [
                          {
                            type: "required",
                            message: "Supplier Price is required",
                          },
                        ],
                      },
                      {
                        dataField: "SupplierUM",
                        gcLabel: "Supplier UM",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        visible:
                          this.baseView.mode === "create" &&
                          this.model.Source != "M",
                        required: true,
                        editorOptions: {
                          dataSource: UnitOfMeasureService.dataSourceConfig(
                            "api/UnitOfMeasure",
                            {
                              select: ["Code", "Description"],
                              filter: ["Inactive", "=", false],
                              sort: [{ selector: "Description", asc: true }],
                            }
                          ),
                          itemTemplate: "UnitOfMeasureTemplate",
                          valueExpr: "Code",
                          displayExpr: "Description",
                          searchExpr: ["Code", "Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                          // hint: this.model.stockUMReadOnly
                          //   ? "Stock UM cannot be changed once the product is transacted upon" //need both
                          //   : "",
                        },
                        validationRules: [
                          {
                            type: "required",
                            message: "Stock UM is required",
                          },
                          {
                            type: "async",
                            validationCallback: this.stockUMExistsRuleCallback,
                            message: "Stock UM does not exist",
                          },
                        ],
                      },
                      {
                        dataField: "SupplierConversion",
                        gcType: "Decimal-6-4",
                        // format: "Decimal-9-2",
                        cssClass: "dx-numberbox-left",
                        editorType: "dxTextBox",
                        editorOptions: {
                          readOnly: false,
                        },
                        visible:
                          this.baseView.mode === "create" &&
                          this.model.Source != "M",
                        required: true,
                      },
                      {
                        dataField: "PrimaryBomCode",
                        gcLabel: "Production BOM",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        visible: this.model.Source == "M",
                        editorOptions: {
                          readOnly: this.baseView.mode == "create",
                          dataSource: ProductService.dataSourceConfig(
                            "api/BOM",
                            {
                              select: [
                                "Code",
                                "Description1",
                                "Status",
                                "BomTypeCode",
                                "ProductCode",
                                "RecordId",
                              ],
                              filter: [
                                ["Status", "=", "A"],
                                "and",
                                ["BomTypeCode", "=", "Production"],
                                "and",
                                ["ProductCode", "=", `${this.baseView.id}`],
                              ],
                              sort: [{ selector: "Code", asc: true }],
                            }
                          ),
                          itemTemplate: "BOMTemplate",
                          valueExpr: "Code",
                          displayExpr: (item) => {
                            if (item)
                              return item.Code + " - " + item.Description1;
                            else return "";
                          },
                          onValueChanged: (e) => {
                            this.onBomCodeChanged(e);
                          },
                          searchExpr: ["Code", "Description1"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                          hint: this.primaryBomCodeHint,
                        },
                      },
                      {
                        dataField: "PlanningBomCode",
                        gcLabel: "Planning BOM",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        visible: this.model.Source == "M",
                        editorOptions: {
                          readOnly: this.baseView.mode == "create",
                          dataSource: ProductService.dataSourceConfig(
                            "api/BOM",
                            {
                              select: [
                                "Code",
                                "Description1",
                                "Status",
                                "BomTypeCode",
                                "ProductCode",
                                "RecordId",
                              ],
                              filter: [
                                ["Status", "=", "A"],
                                "and",
                                ["BomTypeCode", "=", "Planning"],
                                "and",
                                ["ProductCode", "=", `${this.baseView.id}`],
                              ],
                              sort: [{ selector: "Code", asc: true }],
                            }
                          ),
                          itemTemplate: "BOMTemplate",
                          valueExpr: "Code",

                          displayExpr: (item) => {
                            if (item)
                              return item.Code + " - " + item.Description1;
                            else return "";
                          },
                          onValueChanged: (e) => {
                            this.onBomCodeChanged(e);
                          },
                          searchExpr: ["Code", "Description1"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                          hint: this.planningBomCodeHint,
                        },
                      },
                      {
                        dataField: "ShelfLifeMethod",
                        gcLabel: "Shelf Life Method",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        editorOptions: {
                          items: [
                            { Description: "Best Before" },
                            { Description: "Use By" },
                          ],
                          valueExpr: "Description",
                          displayExpr: "Description",
                          searchExpr: ["Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                          onValueChanged: (e) => {
                            this.onShelfLifeMethodValueChanged(e);
                          },
                        },
                        visible: this.model.IsBatchProduct != "No",
                      },
                      {
                        dataField: "ShelfLifeDays",
                        gcLabel: "Shelf Life Days",
                        gcType: "String",
                        editorType: "dxNumberBox",
                        visible: this.model.IsBatchProduct != "No",
                        editorOptions: {
                          readOnly: !this.model.ShelfLifeMethod,
                          onValueChanged: (e) => {
                            this.onShelfLifeDaysValueChanged(e);
                          },
                        },
                      },
                    ]),
                  },
                ],
              },
              //     //**MANUFACTURING group - NOT for September Release*/
              //     {
              //       itemType: "group",
              //       caption: "Manufacturing",
              //       items :[
              //         {
              //           dataField: "Source",
              //           label: {text: "Source"},
              //           id: "source-selectBox",
              //           readOnly: true,
              //           //** ReadOnly in first release*/
              //           validationRules: [
              //               {
              //                 type: "required",
              //                 message: "Source is required",
              //               }
              //           ],
              //           editorType: "dxSelectBox",
              //           editorOptions: {
              //             items: [
              //               {
              //                 value: "B",
              //                 text: "Bought",
              //               },
              //               {
              //                 value: "M",
              //                 text: "Manufactured",
              //               },
              //             ],
              //             valueExpr: "value",
              //             displayExpr: "text",
              //           },
              //         },
              //         {
              //           dataField: "ReleaseMode",
              //           label: {text: "Release Mode"},
              //           id: "releaseMode-selectBox",
              //           readOnly: true,
              //           //** ReadOnly in first release*/
              //           validationRules: [
              //               {
              //                 type: "required",
              //                 message: "Source is required",
              //               }
              //           ],
              //           editorType: "dxSelectBox",
              //           editorOptions: {
              //             items: [
              //               {
              //                 value: "I",
              //                 text: "In Line",
              //               },
              //               {
              //                 value: "S",
              //                 text: "To Stock",
              //               },
              //               {
              //                 value: "",
              //                 text: "None",
              //               },
              //             ],
              //             valueExpr: "value",
              //             displayExpr: "text",
              //           },
              //         }
              //       ],
              //     },
            ],
          },
          {
            itemType: "group",
            caption: "",
            colCount: 3,
            cssClass: "packaging-group",
            items: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "CartonTun",
                    label: { text: "TUN for Carton" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 20,
                    },
                  },
                  {
                    dataField: "CartonPerLayer",
                    label: { text: "Cartons / Layer" },
                    editorType: "dxNumberBox",
                    editorOptions: {
                      min: 0,
                      format: "###,###,###",
                    },
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "CartonPerPallet",
                    label: { text: "Cartons / Pallet" },
                    editorType: "dxNumberBox",
                    editorOptions: {
                      min: 0,
                      format: "###,###,###",
                    },
                  },
                  {
                    dataField: "WorkOrderMaterialCheck",
                    label: { text: "WO Material Check" },
                    editorType: "dxSwitch",
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                visible: this.model.Source == "M",
                items: [
                  {
                    dataField: "StandardReleaseQuantity",
                    label: { text: "Std Release Qty" },
                    editorType: "dxNumberBox",
                    editorOptions: {
                      format: "###,###,##0.0000",
                    },
                  },
                  {
                    dataField: "StandardReleaseTolerance",
                    label: { text: "Std Release Tolerance" },
                    editorType: "dxNumberBox",
                    editorOptions: {
                      format: "###,###,##0.00",
                    },
                  },
                ],
              },
            ],
          },
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "FullDescription",
                label: { text: "Description" },
                gcType: "String",
                editorType: "dxTextArea",
              },
            ],
          },
        ],
      };
    },
    toolbar() {
      return {
        edit: {
          icon: "edit",
          onClick: this.editClick,
          visible: FeatureStorage.checkPermission("Product", "create"),
        },
        save: {
          validationGroup: "formsData",
          ref: "saveButton",
          icon: "floppy",
          // eslint-disable-next-line no-unused-vars
          onClick: async (e) => {
            this.$logger.trackEventButtonClickSave();
            let payload = {
              Code: this.model.Code,
              AlternateProductCode: this.model.Code,
              APN: this.model.APN,
              Description1: this.model.Description1,
              Description2: this.model.Description2,
              Description3: this.model.Description3,
              ProductCategory1Code: this.model.ProductCategory1Code,
              ProductCategory2Code: this.model.ProductCategory2Code,
              ProductCategory3Code: this.model.ProductCategory3Code,
              ProductCategory4Code: this.model.ProductCategory4Code,
              ProductTypeCode: this.model.ProductTypeCode,
              ProductSizeCode: this.model.ProductSizeCode,
              TaxCode: this.model.TaxCode,
              Inactive: this.model.Active == true ? "N" : "Y",
              IsPrimeCostItem: this.model.IsPrimeCostItem == true ? "Y" : "N",
              StockItem: this.model.StockItem == true ? "Y" : "N",
              AvailableForSale: this.model.AvailableForSale == true ? "Y" : "N",
              UnitOfMeasureCode: this.model.UnitOfMeasureCode,
              IsBatchProduct: this.model.IsBatchProduct,
              Source: this.model.Source,
              ReleaseMode: this.model.ReleaseMode,
              // Manufacturer: this.model.Manufacturer,
              PurchaseDescription1: this.model.PurchaseDescription1,
              PurchaseDescription2: this.model.PurchaseDescription2,
              MLORDays: this.model.MLORDays,
              Currency: this.model.Currency,
              PreferredSupplier: this.model.PreferredSupplier,
              SellPrice: this.model.SellPrice,
              SupplierConversion: this.model.SupplierConversion,
              SupplierUM: this.model.SupplierUM,
              SupplierPrice: this.model.SupplierPrice,
              // Rank:1,
              IsKit: this.model.KitItem ? "Y" : "N",
              ProductKit: this.getProductKit(),
              Attribute01: this.model.Attribute01,
              Attribute02: this.model.Attribute02,
              Attribute03: this.model.Attribute03,
              Attribute04: this.model.Attribute04,
              Attribute05: this.model.Attribute05,
              Attribute06: this.model.Attribute06,
              Attribute07: this.model.Attribute07,
              Attribute08: this.model.Attribute08,
              Attribute09: this.model.Attribute09,
              Attribute10: this.model.Attribute10,
              Attribute11: this.model.Attribute11,
              Attribute12: this.model.Attribute12,
              Attribute13: this.model.Attribute13,
              Attribute14: this.model.Attribute14,
              Attribute15: this.model.Attribute15,
              Attribute16: this.model.Attribute16,
              Attribute17: this.model.Attribute17,
              Attribute18: this.model.Attribute18,
              Attribute19: this.model.Attribute19,
              Attribute20: this.model.Attribute20,

              // support Manufacturing and Batch fields
              PackSize: this.model.PackSize,
              PrimaryBomCode: this.model.PrimaryBomCode,
              PlanningBomCode: this.model.PlanningBomCode,
              ReleaseBatchMethod: this.model.ReleaseBatchMethod,
              ShelfLifeMethod: this.model.ShelfLifeMethod,

              BestBeforeShelfLife:
                this.model.IsBatchProduct != "No" && this.model.ShelfLifeMethod == "Best Before"
                  ? this.model.BestBeforeShelfLife
                  : -1,
              UseByShelfLife:
                this.model.IsBatchProduct != "No" && this.model.ShelfLifeMethod == "Use By"
                  ? this.model.UseByShelfLife
                  : -1,

              // added from #64138
              StorageTemperatureCode: this.model.StorageTemperatureCode,
              StockFlag: this.model.StockJournal == true ? "Y" : "N",
              FullDescription: this.model.FullDescription,

              // added from #64141
              StandardReleaseQuantity:
                this.model.StandardReleaseQuantity.roundNumber(4),
              StandardReleaseTolerance:
                this.model.StandardReleaseTolerance.roundNumber(2),
              CartonTun: this.model.CartonTun,
              WorkOrderMaterialCheck:
                this.model.WorkOrderMaterialCheck == true ? "Y" : "N",

              // added from #64137
              MarkupPercentage: this.model.MarkupPercentage,
            };

            // added from #64141
            if (this.model.CartonPerPallet) {
              payload.CartonPerPallet = this.model.CartonPerPallet;
            }

            // added from #64141
            if (this.model.CartonPerLayer) {
              payload.CartonPerLayer = this.model.CartonPerLayer;
            }

            const mainForm = await validationEngine.validateGroup("formsData");
            const toolbarForm = await validationEngine.validateGroup(
              "toolbarForm"
            );
            const toolbarActive = await validationEngine.validateGroup(
              "toolbarActive"
            );

            var value = mainForm.brokenRules.concat(
              toolbarForm.brokenRules.concat(toolbarActive.brokenRules)
            );

            if (
              !mainForm.isValid ||
              !toolbarForm.isValid ||
              !toolbarActive.isValid
            ) {
              this.addErrorMessagesFromValidationResult({
                brokenRules: value,
              });
              this.displayCustomValidationSummary();
              return;
            }
            this.showLoading(true);
            await ProductService.saveProduct(this.baseView.mode, payload)
              .then((res) => {
                this.showLoading(false);
                this.$notify("Product Details saved successfully", "success");
                this.$logger.debug("response", res);

                this.postSave();
              })
              .catch((error) => {
                this.displayServerError(error, "Product save failed");
              });
          },
        },
        audit: {
          icon: "clock",
          visible: function () {
            return this.baseView.mode != "create";
          },
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
        copy: {
          icon: "copy",
          items: [
            {
              text: "Copy Product",
              key: "copyProduct",
            },
          ],
          keyExpr: "key",
          displayExpr: "text",
          showArrowIcon: false,
          dropDownOptions: {
            width: 150,
          },
          stylingMode: "text",
          onItemClick: () => {
            this.setCopyProductVisible(true);
          },
          visible: FeatureStorage.checkPermission("Product", "create"),
        },
      };
    },
    tabs() {
      if (this.dataLoaded)
        if (this.baseView.mode == "create") {
          return [
            {
              text: "Details",
              path: `/Product/review/${this.baseView.id}`,
              applicationFeatureCode: "Product",
            },
          ];
        } else {
          return ProductTabs(this.baseView.id);
        }
      else return [];
    },

    IsIsPrimeCostItemEditable() {
      if (this.model.KitItem) return false;
      else if (this.isProductHasMovements) return false;
      else return true;
    },

    // Copy Product Popup
    getCopyProductVisible() {
      return this.CopyProductVisible;
    },
  },
  methods: {
    onBomCodeChanged(e) {
      let items = e.component.getDataSource().items();
      let selectedBom = items.find((x) => x.Code === e.value);
      // set the hint for editor
      e.component.option("hint", `${e.value} - ${selectedBom.Description1}`);
    },
    async loadProductDetailData(id) {
      this.dataLoaded = false;
      this.showLoading(true);

      try {
        const response = await ProductService.getByCode(id);
        const data = response.data.value[0];
        if (!data) return;

        // Destructure common fields
        const {
          Code,
          AlternateProductCode,
          APN,
          Inactive,
          Description1,
          Description2,
          Description3,
          ProductCategory1Code,
          ProductCategory2Code,
          ProductCategory3Code,
          ProductCategory4Code,
          ProductTypeCode,
          ProductSizeCode,
          TaxCode,
          IsPrimeCostItem,
          StockItem,
          AvailableForSale,
          UnitOfMeasureCode,
          CartonTun,
          CartonPerLayer,
          CartonPerPallet,
          IsKit,
          PackSize,
          PrimaryBomCode,
          PlanningBomCode,
          PlanningBomDescription,
          PrimaryBomDescription,
          ReleaseBatchMethod,
          ShelfLifeMethod,
          StorageTemperatureCode,
          StockFlag,
          FullDescription,
          StandardReleaseQuantity,
          StandardReleaseTolerance,
          WorkOrderMaterialCheck,
          MarkupPercentage,
          BestBeforeShelfLife,
          UseByShelfLife,
          IsBatchProduct,
          Source,
          ReleaseMode,
          PurchaseDescription1,
          PurchaseDescription2,
          MLORDays,
          DateChanged,
          CreatedBy,
          ChangedBy,
          DateCreated,
        } = data;

        // Assign core model fields
        Object.assign(this.model, {
          Code,
          AlternateProductCode,
          APN,
          Active: Inactive === "N",
          Description1,
          Description2,
          Description3,
          ProductCategory1Code,
          ProductCategory2Code,
          ProductCategory3Code,
          ProductCategory4Code,
          ProductTypeCode,
          ProductSizeCode,
          TaxCode,
          IsPrimeCostItem,
          StockItem: StockItem !== "N",
          AvailableForSale: AvailableForSale !== "N",
          UnitOfMeasureCode,
          CartonTun,
          CartonPerLayer,
          CartonPerPallet,
          KitItem: IsKit === "Y",
          PackSize,
          PrimaryBomCode,
          PrimaryBomDescription,
          PlanningBomCode,
          PlanningBomDescription,
          ReleaseBatchMethod,
          ShelfLifeMethod,
          StorageTemperatureCode,
          StockJournal: StockFlag === "Y",
          FullDescription,
          StandardReleaseQuantity,
          StandardReleaseTolerance,
          WorkOrderMaterialCheck: WorkOrderMaterialCheck === "Y",
          MarkupPercentage,
          ShelfLifeDays:
            BestBeforeShelfLife > 0
              ? BestBeforeShelfLife
              : UseByShelfLife > 0
              ? UseByShelfLife
              : 0,
          Source,
          ReleaseMode,
          PurchaseDescription1,
          PurchaseDescription2,
          MLORDays,
          DateChanged,
          CreatedBy,
          ChangedBy,
          DateCreated,
          BestBeforeShelfLife,
          UseByShelfLife,
        });

        this.planningBomCodeHint =
          PlanningBomCode && PlanningBomDescription
            ? `${PlanningBomCode} - ${PlanningBomDescription}`
            : "";
        this.primaryBomCodeHint =
          PrimaryBomCode && PrimaryBomDescription
            ? `${PrimaryBomCode} - ${PrimaryBomDescription}`
            : "";

        // Attributes 01-20 (bulk assign)
        for (let i = 1; i <= 20; i++) {
          this.model[`Attribute${String(i).padStart(2, "0")}`] =
            data[`Attribute${String(i).padStart(2, "0")}`];
        }

        // Kit tab visibility
        ProductTabsVisibility({
          text: "Kit Components",
          value: this.model.KitItem,
        });

        // Normalize batch product type
        this.model.IsBatchProduct =
          {
            manual: "Manual",
            auto: "Auto",
            nextno: "NextNo",
          }[IsBatchProduct.toLowerCase()] || "No";

        if (
          this.model.IsBatchProduct !== "No" &&
          this.baseView.mode === "edit"
        ) {
          this.checkProductMovements();
        }

        // Fire off related checks in parallel
        const [descRes, activeTransactionsRes, stockRes, txnRes, uomRes] =
          await Promise.all([
            ProductService.getProductFullDescription(Code),
            ProductService.getActiveTransactions(Code),
            ProductService.checkProductStock(Code),
            ProductService.checkTransactions(Code),
            UnitOfMeasureService.getByCode(UnitOfMeasureCode),
          ]);

        if (descRes.data.value.length > 0) {
          this.model.FullDescription = descRes.data.value[0].FullDescription;
        }

        this.inactivateValidationMessage = "";

        if (activeTransactionsRes.data.value.length > 0) {
          let transaction = activeTransactionsRes.data.value[0];

          /**
           *
           * HowManyActivePurchaseOrders
           * HowManyActiveSalesOrders
           * HowManyActiveSalesQuotes
           * HowManyActiveWorksOrders
           * HowManyOnHandStock
           * IsComponentOfActiveKit
           * IsMaterialOnActiveBOM
           * IsMaterialOnActiveWorkOrder
           *
           */
          if (transaction.HowManyActiveSalesQuotes > 0) {
            this.model.activeReadOnly = true;
            this.inactivateValidationMessage = `This product cannot be inactivated because it is currently linked to an active Sales Quote. Please resolve these links before changing the product status.`;
          } else if (transaction.HowManyActivePurchaseOrders > 0) {
            this.model.activeReadOnly = true;
            this.inactivateValidationMessage =
              "This product cannot be inactivated because it is currently linked to an active Purchase Order. Please resolve these links before changing the product status.";
          } else if (transaction.HowManyActiveSalesOrders > 0) {
            this.model.activeReadOnly = true;
            this.inactivateValidationMessage =
              "This product cannot be inactivated because it is currently linked to an active Sales Order. Please resolve these links before changing the product status.";
          } else if (transaction.IsMaterialOnActiveBOM == 1) {
            this.model.activeReadOnly = true;
            this.inactivateValidationMessage =
              "This product cannot be inactivated because it is currently linked to an active Bill of Material (BOM). Please resolve these links before changing the product status.";
          } else if (transaction.IsComponentOfActiveKit == 1) {
            this.model.activeReadOnly = true;
            this.inactivateValidationMessage =
              "This product cannot be inactivated because it is currently used as a component within active Kits. It is part of a Kit in an active purchase order or an active sales order. Please remove the product from all active Kits before changing its status.";
          } else if (transaction.HowManyOnHandStock > 0) {
            this.model.activeReadOnly = true;
            this.inactivateValidationMessage =
              "This product cannot be inactivated because the Onhand stock is not 0.0000. Please ensure all stock is cleared or adjusted to 0.0000 before attempting to change the product status.";
          } else {
            this.model.activeReadOnly = false;
          }
        }

        if (stockRes.data.value.length > 0) {
          this.model.isBatchProductReadOnly = true;
          this.model.activeReadOnly = true;
          this.isBatchMethodEditable = false;
        }

        if (txnRes.data.value.length > 0) {
          this.model.stockItemReadOnly = true;
          this.model.stockUMReadOnly = true;
        }

        if (
          uomRes.data.value.length > 0 &&
          uomRes.data.value[0].Inactive === false
        ) {
          this.model.UnitOfMeasureCode = uomRes.data.value[0].Code;
        }

        this.refreshView();

        // Fix case sensitivity for remote selectbox data
        if (this.$refs["product-details"]) {
          this.validateFormConfig(this.$refs["product-details"].instance);
        }
      } catch (error) {
        this.displayServerError(error);
      } finally {
        this.dataLoaded = true;
        this.showLoading(false);
      }
    },
    onShelfLifeMethodValueChanged(e) {
      if (e.value == "Best Before") {
        this.model.BestBeforeShelfLife = this.model.UseByShelfLife;
      } else {
        this.model.UseByShelfLife = this.model.BestBeforeShelfLife;
      }
    },
    onShelfLifeDaysValueChanged(e) {
      if (this.model.ShelfLifeMethod == "Best Before") {
        this.model.BestBeforeShelfLife = e.value;
      } else {
        this.model.UseByShelfLife = e.value;
      }
    },
    onUnitOfMeasureCodeChanges(e) {
      this.model.UnitOfMeasureCode = e.value;
      if (e.value == "M") this.model.SupplierUM = this.model.UnitOfMeasureCode;
    },
    onSourceValueChanged(e) {
      this.model.Source = e.value;
      if (e.value == "M") {
        this.model.SupplierConversion = 1;
        this.model.SupplierUM = this.model.UnitOfMeasureCode;
        this.model.PreferredSupplier = getFactorByCode(73).Factorc;
        if (this.model.PreferredSupplier)
          SupplierService.getByCode(this.model.PreferredSupplier).then(
            (res) => {
              var data = res.data.value[0];
              this.model.Currency = data.CurrencyCode;
            }
          );
      } else {
        this.model.SupplierConversion = 1;
        this.model.SupplierUM = undefined;
        this.model.PreferredSupplier = undefined;
        this.model.Currency = undefined;
      }
    },
    onKitItemValueChanged(e) {
      this.model.KitItem = e.value;
      if (e.value) {
        this.model.IsBatchProduct = "No";
        this.model.IsPrimeCostItem = true;
        this.showProductKits();
      }
    },
    onIsPrimeCostItemValueChanged(e) {
      this.model.IsPrimeCostItem = e.value;
      if (!e.value) {
        this.model.MarkupPercentage = 0;
      }
    },
    getProductKit() {
      if (!this.model.KitItem || !this.productKitDetails) return {};
      else {
        return {
          KitCode: this.model.Code,
          SellPrice: this.productKitDetails.dataModel.KitStdSell,
          KitCost: this.productKitDetails.dataModel.KitStdCost,
          StockTakeMethod: this.productKitDetails.dataModel.StocktakeMethod,
          DateChanged: this.productKitDetails.dataModel.DateChanged,
          ProductKitDetails: this.getProductKitDetails(),
        };
      }
    },
    getProductKitDetails() {
      var lines = [];
      this.productKitDetails.detailModel.forEach((element) => {
        lines.push({
          ComponentCode: element.ProductCode,
          Quantity: element.Quantity,
        });
      });

      return lines;
    },
    showProductKits() {
      this.visibleProductKits = !this.visibleProductKits;
    },
    hideProductKits(save, data) {
      this.visibleProductKits = false;

      if (save) {
        this.productKitDetails = { ...data };
      } else {
        if (data.detailModel.length == 0) this.model.KitItem = false;
      }
    },
    setActive(value) {
      this.model.Active = value;
    },
    setCurrencyCode(currencyCode) {
      this.model.Currency = currencyCode;
    },
    onBatchMethodChanged(e) {
      if (e.value === "No") this.model.MLORDays = -1;
    },
    postSave() {
      this.setIgnoreRouteChangeConfirmation();
      this.$router.push({
        path: `/product/review/${this.model.Code}`,
      });
    },
    editClick() {
      this.$router
        .push({
          path: `/product/edit/${this.baseView.id}`,
        })
        .then(() => {
          this.checkProductMovements();
        });
    },
    async checkProductMovements() {
      await ProductService.checkProductMovements(this.baseView.id).then(
        (res) => {
          if (res.data.value.length > 0) {
            this.isProductHasMovements = true;
          } else {
            this.isProductHasMovements = false;
          }
        }
      );
    },
    onDescription1Changed() {
      this.model.PurchaseDescription1 = this.model.Description1;
    },
    onDescription2Changed() {
      this.model.PurchaseDescription2 = this.model.Description2;
    },
    backButtonFunction() {
      this.$router.push({
        path: "/product",
      });
    },

    stockUMExistsRuleCallback(params) {
      return new Promise((resolve) => {
        UnitOfMeasureService.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == false
          ) {
            this.model.UnitOfMeasureCode = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.UnitOfMeasureCode = "";
            resolve(false);
          }
        });
      });
    },
    typeExistsRuleCallback(params) {
      return new Promise((resolve) => {
        ProductTypeService.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.ProductTypeCode = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.ProductTypeCode = "";
            resolve(false);
          }
        });
      });
    },
    sizeExistsRuleCallback(params) {
      return new Promise((resolve) => {
        if (params.value == "") {
          resolve(true);
        }

        ProductSizeService.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.ProductSizeCode = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.ProductSizeCode = "";
            resolve(false);
          }
        });
      });
    },
    category4ExistsRuleCallback(params) {
      return new Promise((resolve) => {
        if (params.value == "") {
          resolve(true);
        }

        ProductCategory4Service.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.ProductCategory4Code = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.ProductCategory4Code = "";
            resolve(false);
          }
        });
      });
    },
    category3ExistsRuleCallback(params) {
      return new Promise((resolve) => {
        ProductCategory3Service.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.ProductCategory3Code = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.ProductCategory3Code = "";
            resolve(false);
          }
        });
      });
    },
    category2ExistsRuleCallback(params) {
      return new Promise((resolve) => {
        ProductCategory2Service.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.ProductCategory2Code = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.ProductCategory2Code = "";
            resolve(false);
          }
        });
      });
    },
    category1ExistsRuleCallback(params) {
      return new Promise((resolve) => {
        ProductCategory1Service.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.ProductCategory1Code = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.ProductCategory1Code = "";
            resolve(false);
          }
        });
      });
    },
    taxCodeExistsRuleCallback(params) {
      return new Promise((resolve) => {
        TaxCategoryService.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.TaxCode = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.TaxCode = "";
            resolve(false);
          }
        });
      });
    },
    alternateProductCodeExistsRuleCallback(params) {
      return new Promise((resolve) => {
        ProductService.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.AlternateProductCode = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.AlternateProductCode = "";
            resolve(false);
          }
        });
      });
    },

    // Copy Product Popup
    setCopyProductVisible(value) {
      this.popUpConfig = {
        ProductCode: this.model.Code,
        Description1: this.model.Description1,
        Description2: this.model.Description2,
        Description3: this.model.Description3,
      };
      this.CopyProductVisible = value;
    },
  },
};
</script>

<style lang="scss">
.kit-edit {
  height: 100%;
  display: flex;
  align-items: center;

  .kitItem-Template {
    margin-top: 3px;
    .label-content {
      cursor: pointer;
      color: #03a9f4;
    }
  }
}

.attribute-content {
  padding-top: 12px !important;
  > div {
    background-color: white;

    > form {
      padding: 12px;
      .dx-scrollable-container {
        margin: 0 !important;
        padding: 0 !important;
        .dx-layout-manager {
          padding-right: unset !important;
        }
      }
    }
  }
}

.product-detail-form {
  .packaging-group {
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }
}
</style>
